/**
 * Created by RUSS_ on 08.05.2018
 */
export function isAtLeatOneCookiesOfListAccepted(list) {
  for (let i = 0; i < list.length; i++) {
    if (list[i].accepted) {
      return true;
    }
  }
  return false;
}

export function allCookiesOfListAccepted(list) {
  for (let i = 0; i < list.length; i++) {
    if (!list[i].accepted) {
      return false;
    }
  }
  return true;
}

export function getCurrentConfigAsJsonFromList(list) {
  let result = [];
  for (let i = 0; i < list.length; i++) {
    result.push(list[i]);
    //   name: list[i].name,
    //   id: list[i].id,
    //   accepted: list[i].accepted,
    //   domains: list[i].domains,
    //   immutable: list[i].immutable
    // });
  }
  return result;
}

export function getCookieById(settingsArray, id) {
  for (let i = 0; i < settingsArray.length; i++) {
    if (settingsArray[i].id === id) {
      return settingsArray[i];
    }
  }
  return null;
}

export function proveOneCategory(settingsJson, list) {
  for (let i = 0; i < list.length; i++) {
    for (let j = 0; j < settingsJson.length; j++) {
      if (settingsJson[j].id === list[i].id) {
        list[i].accepted = settingsJson[j].accepted;
      }
    }
  }
  return list;
}

export function toggleCategory(category, enabled) {
  for (let i = 0; i < category.list.length; i++) {
    category.list[i].accepted = enabled;
  }
  return category;
}

export function convertToConfigFromStorage(settingsText, CookieConfig) {
  const settingsJson = JSON.parse(settingsText);
  CookieConfig.necessary.list = proveOneCategory(
    settingsJson,
    CookieConfig.necessary.list
  );
  CookieConfig.preferences.list = proveOneCategory(
    settingsJson,
    CookieConfig.preferences.list
  );
  CookieConfig.statistics.list = proveOneCategory(
    settingsJson,
    CookieConfig.statistics.list
  );
  CookieConfig.marketing.list = proveOneCategory(
    settingsJson,
    CookieConfig.marketing.list
  );
  return CookieConfig;
}

export function clone(object) {
  return JSON.parse(JSON.stringify(object));
}

export function getConfigAsArrayJson(config) {
  let result = [];
  result = result.concat(getCurrentConfigAsJsonFromList(config.necessary.list));
  result = result.concat(
    getCurrentConfigAsJsonFromList(config.preferences.list)
  );
  result = result.concat(
    getCurrentConfigAsJsonFromList(config.statistics.list)
  );
  result = result.concat(getCurrentConfigAsJsonFromList(config.marketing.list));
  return clone(result);
}



// WEBPACK FOOTER //
// ./src-cookie-manager/utils/cookie-config-helper.js